export const getCssVariable = (
  variableName: string,
  element: Element = document.documentElement
): string => getComputedStyle(element).getPropertyValue(variableName).trim();
